import {Box, Text, Heading, Center, Link} from '@chakra-ui/react';
import * as React from 'react';
import {SlideInBox} from './slide-in-box';

export const OasisCharity: React.FC = () => {
  return (
    <Center bg="#EDDFFE" color="#712f8b">
      <Box maxW="880px" px="40px" py={{base: '60px', md: '110px'}}>
        <Box>
          <SlideInBox>
            <Heading fontSize={{base: '25px', md: '36px'}} zIndex={5}>
              Oasis Charity
            </Heading>
          </SlideInBox>
          <Text fontSize="18px" mt="10px" mb={6}>
            Oasis Domestic Abuse Service supports people affected by domestic
            abuse in Kent - in refuge, in the community and through specialist
            services for children and young people. Their vision is of a world
            free from abusive relationships where every person is safe at home.
            To make a donation to support their work, please go to{' '}
            <Link href="https://www.oasisdaservice.org/support-us/donate/">
              www.oasisdaservice.org/support-us/donate
            </Link>
            .
          </Text>
        </Box>
      </Box>
    </Center>
  );
};
